export default "__VITE_ASSET__5a76c123__"